import React, { Component } from "react";

export default class HomeSubHeader extends Component {
  render() {
    return (
      <div className="header-bottom">
        <div className="container">
          <div className="header-navs header-navs-left" id="kt_header_navs">
            <div className="tab-content">
              <div
                className="tab-pane py-5 p-lg-0 show active"
                id="kt_header_tab_1"
              >
                <div
                  id="kt_header_menu"
                  className="header-menu header-menu-mobile header-menu-layout-default"
                >
                  <ul className="menu-nav">
                    <li
                      className="menu-item menu-item-active"
                      aria-haspopup="true"
                    >
                      <a href="#" className="menu-link">
                        <span className="menu-text">Generate</span>
                      </a>
                    </li>
                    <li className="menu-item" aria-haspopup="true">
                      <a href="#" className="menu-link">
                        <span className="menu-text">Saved</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
